import {Component} from "@angular/core";
import {NbCardModule, NbLayoutModule} from "@nebular/theme";
import {NbAuthModule} from "@nebular/auth";
import {LogoComponent} from "../@theme/components";
import {RouterOutlet} from "@angular/router";
import {TranslateModule} from "@ngx-translate/core";

@Component({
    selector: 'app-microsoft-login',
    styleUrls: [],
    templateUrl: './microsoft-login.component.html',
    standalone: true,
    imports: [
        NbLayoutModule,
        NbCardModule,
        NbAuthModule,
        LogoComponent,
        RouterOutlet,
        TranslateModule,
    ],
})
export class MicrosoftLoginComponent {

}
